export {AuctionModule} from './auctionModule';
